module.exports = __webpack_public_path__ + "static/media/zw.25d67323.svg";